<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
 
  <wiz-list
    #imgList
    width="100%"
    height="100%"
    [wizItemRenderer]="thumbRenderer"
    [dragEnabled]="true"
    [dropEnabled]="true"
    [dragMove]="true"
    [enableSelfReorder]="true"
    [shopDropIndicator]="true"
    [wizDataProvider]="thumbDS"
    [itemHeight]="50"
  >
  </wiz-list>

  <wiz-hgroup width="100%" horizontalAlign="space-between">
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'arrow-left'"
      (wizClick)="doCancel()"
      [wizLabel]="'$.common.cancel.$'"
    ></wiz-button>
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.ok.$'"
      [wizIcon]="'arrow-right'"
      [iconPlacement]="'right'"
      (wizClick)="save()"
    ></wiz-button>
  </wiz-hgroup>

</wiz-vgroup>
